<template>
  <div class="app flex-row">
    <div class="container-fluid">

      <b-row>
        <b-col md="12">
          <h5>Borrando Cache</h5>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Session from '@/handler/session'

  export default {
    data () {
      return {

      }
    },
    mounted() {
      this.clear()
    },
    methods: {
      clear () {
        var result = Session.removeSessionAll()
      }
    },
  }
</script>

<style>

</style>
